// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__16EO5","content":"ManualTimeModal_content__2d5I3"};